import React, { Component, useCallback } from 'react';
import logo from './mns-logo.png';
import { Main } from './components/Main';
import { useMappedState } from 'redux-react-hook';
import { DirectoryStoreState } from './types';
import { QueryParams } from './utils/routing';

export const App: React.FC<{}> = () => {
  const integrationUrl = useMappedState(
    useCallback((state: DirectoryStoreState) => state.queryString.integrationURL, [])
  );
  const url = integrationUrl ? `?${QueryParams.IntegrationURL}=${integrationUrl}` : '/';

  return (
    <div className="app">
      <header>
        <a href={url}>
          <img src={logo} width={112} alt="M&S Store Directory logo" />
        </a>
        <h2>Store Directory</h2>
      </header>
      <Main />
    </div>
  );
};

export default App;
